import useCheckoutContext from './useCheckoutContext';

function useStickyCheckoutToggle(show): void {
  const { setShowStickyCheckoutFooter } = useCheckoutContext();
  setShowStickyCheckoutFooter(show);
}

export default useStickyCheckoutToggle;
